<div class="modal-backdrop" *ngIf="loading">
  <div class="loader-container">
    <div class="loading-overlay-spinner"></div>
  </div>
</div>
